import React, { Component, Fragment } from 'react';
import styled from 'styled-components';
import MediaQuery from 'react-responsive';

import { getOnboardUser, postOnboardUser } from 'actions/redirectionActions';

import LandlordLogo from 'components/shared/LandlordLogo';
import LoginNavBar from 'navigation/login/loginWithBackground/LoginNavBar';

import RegistrationForm from './RegistrationForm';
import { updateLanguage } from 'react-localize-redux';

import { connect } from 'react-redux';

import { MdWarning as WarningIcon } from 'react-icons/md';
import { BounceLoader } from 'halogenium';

import {
  StyledContainer,
  StyledContainerOverlay,
  StyledCard,
  StyledCardContent,
} from 'helpers/StyledLoginComponentsHelper';
import LoginHelpDialog from 'navigation/LoginHelpDialog';

import { AccentColor } from 'helpers/AccentColorHelper';
import InvalidInvitationToken from 'errors/InvalidInvitationToken';
import VerificationFailed from 'errors/VerificationFailed';
import {
  getTranslatedString,
  getCurrentLocale,
  getLandlordVerbiageOrTranslatedString,
} from 'helpers/i18n';

const StyledRow = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  padding: 24px;
  @media (max-width: 900px) {
    flex-direction: column;
  }
`;

const StyledColumn = styled.div`
  position: relative;
  width: 50%;
  display: flex;
  flex: auto;
  @media (max-width: 900px) {
    width: 100%;
  }
`;

const StyledLoginMessageH2 = styled.h2`
  padding: 0 0 10px;
  margin-top: 5px;
  font-size: 24px;
`;

const StyledMobileContainer = styled.div`
  font-family: 'Circular', sans-serif !important;
  padding: 24px;
`;

const StyledMobileCentered = styled.div`
  text-align: center;
  margin-top: 24px;
`;

const StyledBounceLoader = styled(BounceLoader)``;

const StyledLoadingColumn = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  flex: auto;
  justify-content: center;
  align-items: center;
`;

export default connect(
  (store) => {
    return {
      initialValues: store.redirection.onboardUser,
      invitationToken: store.redirection.invitation_token,
      userType: store.redirection.userType,
      heroImageUrl: store.userTypes.heroImageUrl,
      greetingNameType: store.userTypes.greetingNameType,
    };
  },
  {
    getOnboardUser,
    postOnboardUser,
    updateLanguage,
  }
)(
  class UserOnboarding extends Component {
    constructor(props) {
      super(props);
      this.state = {
        errorMessage: null,
        isRegistering: true,
        showInvalidTokenErrorPage: false,
        showVerificationFailedPage: false,
        showLoading: true,
        loginHelpOpen: false,
      };
    }

    handleLoginHelpOpenClose = (openClose) => {
      this.setState({
        loginHelpOpen: openClose,
      });
    };

    handleLanguageChange = () => {
      const languageCode = getCurrentLocale() === 'fr' ? 'en' : 'fr';
      this.props.updateLanguage(languageCode);
      localStorage.setItem('locale', languageCode);
      this.forceUpdate();
    };

    UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.invitationToken && !this.props.invitationToken) {
        this.props
          .getOnboardUser(nextProps.invitationToken, nextProps.userType)
          .then((response) => {
            const error = response.value && response.value.error;
            if (error) {
              this.setState({
                showInvalidTokenErrorPage: true,
                showLoading: false,
              });
            } else {
              this.setState({ isRegistering: false, showLoading: false });
            }
            const languageCode = response.value && response.value.language_code;
            if (languageCode) {
              this.props.updateLanguage(languageCode);
              localStorage.setItem('locale', languageCode);
              this.forceUpdate();
            }
          });
      }
    }

    register = (values) => {
      this.setState({
        isRegistering: true,
      });
      values['language_code'] = getCurrentLocale();
      this.props.postOnboardUser(this.props.invitationToken, values).then((response) => {
        const error = response.value && response.value.error;
        if (error && error.code === 'VERIFICATION_FAILED') {
          this.setState({
            showVerificationFailedPage: true,
          });
        } else if (error && error.code === 'commonPassword') {
          this.setState({
            errorMessage: error.message,
          });
        }
      });
    };

    render() {
      if (this.state.showInvalidTokenErrorPage) return <InvalidInvitationToken />;

      if (this.state.showVerificationFailedPage) return <VerificationFailed />;

      return (
        <Fragment>
          {this._renderDesktop()}
          {this._renderMobile()}
          <LoginHelpDialog
            isOpen={this.state.loginHelpOpen}
            handleClose={() => this.handleLoginHelpOpenClose(false)}
            stage="passwordReset"
          />
        </Fragment>
      );
    }

    _renderDesktop = () => {
      const { userType } = this.props;

      const submitMessage = this.state.isRegistering
        ? getTranslatedString('onboarding.tenant.creatingAccount')
        : getTranslatedString('onboarding.tenant.getStarted');

      let helpLink =
        'https://yuhu.zendesk.com/hc/en-us/categories/360000073757-Partner-Center-Residents';
      if (userType === 'landlord' || userType === 'maintenance') {
        helpLink =
          'https://yuhu.zendesk.com/hc/en-us/categories/360000075758-Partner-Center-Landlords';
      }

      return (
        <MediaQuery query="(min-device-width: 750px)">
          <StyledContainer img={this.props.heroImage} ref="appContainer">
            <StyledContainerOverlay img={this.props.heroImage}>
              <LoginNavBar
                img={this.props.heroImage}
                handleLanguageChange={this.handleLanguageChange}
                handleLoginHelpOpenClose={this.handleLoginHelpOpenClose}
                helpLink={helpLink}
                isAuthenticating={this.state.showLoading}
              />
              <StyledRow>
                <StyledColumn>
                  <StyledCard style={{ overflowY: 'auto' }}>
                    <StyledCardContent contentFullWidth>
                      {this.state.showLoading && this._renderLoading()}
                      {!this.state.showLoading && (
                        <div className="row">
                          <div className="col-sm-10 col-sm-offset-1">
                            <div className="row" id={'main-login-message'}>
                              <LandlordLogo
                                fontSize="90px"
                                maxWidth="273px"
                                height="100px"
                                textHeight="70px"
                                textAlign="left"
                              />
                              <StyledLoginMessageH2 aria-level="1">
                                {getLandlordVerbiageOrTranslatedString(
                                  'onboarding.tenant.confirmYourAccount',
                                  {
                                    name: this.props.initialValues.first_name,
                                  }
                                )}
                              </StyledLoginMessageH2>
                              {this.state.errorMessage && (
                                <div
                                  className="error-message"
                                  id="error-message"
                                  data-testid="login-error-message"
                                >
                                  <WarningIcon /> {this.state.errorMessage}
                                </div>
                              )}
                            </div>

                            <RegistrationForm
                              onSubmit={this.register}
                              isRegistering={this.state.isRegistering}
                              submitMessage={submitMessage}
                              initialValues={this.props.initialValues}
                              emailDisabled={true}
                              updateLanguage={updateLanguage}
                              forceUpdate={() => this.forceUpdate()}
                            />
                          </div>
                        </div>
                      )}
                    </StyledCardContent>
                  </StyledCard>
                </StyledColumn>
                <StyledColumn />
              </StyledRow>
            </StyledContainerOverlay>
          </StyledContainer>
        </MediaQuery>
      );
    };
    _renderLoading = () => (
      <StyledRow>
        <StyledLoadingColumn>
          <StyledBounceLoader color={AccentColor()} />
        </StyledLoadingColumn>
      </StyledRow>
    );

    _renderMobile = () => {
      const { userType } = this.props;

      const submitMessage = this.state.isRegistering
        ? getTranslatedString('onboarding.tenant.creatingAccount')
        : getTranslatedString('onboarding.tenant.getStarted');

      let helpLink =
        'https://yuhu.zendesk.com/hc/en-us/categories/360000073757-Partner-Center-Residents';
      if (userType === 'landlord' || userType === 'maintenance') {
        helpLink =
          'https://yuhu.zendesk.com/hc/en-us/categories/360000075758-Partner-Center-Landlords';
      }
      return (
        <MediaQuery query="(max-device-width: 750px)">
          {this.state.showLoading && this._renderLoading()}
          {!this.state.showLoading && (
            <Fragment>
              <LoginNavBar
                mobile
                img={this.props.heroImage}
                handleLanguageChange={this.handleLanguageChange}
                handleLoginHelpOpenClose={this.handleLoginHelpOpenClose}
                helpLink={helpLink}
              />

              <StyledMobileContainer>
                <StyledMobileCentered id={'main-login-message'}>
                  <LandlordLogo fontSize="90px" maxWidth="273px" height="100px" textHeight="70px" />
                  <StyledLoginMessageH2 aria-level="1">
                    {getLandlordVerbiageOrTranslatedString('onboarding.tenant.confirmYourAccount', {
                      name: this.props.initialValues.first_name,
                    })}
                  </StyledLoginMessageH2>
                  {this.state.errorMessage && (
                    <div
                      className="error-message"
                      id="error-message"
                      data-testid="login-error-message"
                    >
                      <WarningIcon /> {this.state.errorMessage}
                    </div>
                  )}
                </StyledMobileCentered>

                <RegistrationForm
                  onSubmit={this.register}
                  isRegistering={this.state.isRegistering}
                  submitMessage={submitMessage}
                  initialValues={this.props.initialValues}
                  emailDisabled={true}
                  updateLanguage={updateLanguage}
                  forceUpdate={() => this.forceUpdate()}
                  mobile
                />
              </StyledMobileContainer>
            </Fragment>
          )}
        </MediaQuery>
      );
    };
  }
);
